import { DialogData } from './dialog.model';
import { TableComponent } from './../../shared/ui/table/table.component';
import { Observable } from 'rxjs';
export interface ISelectItem<> {
  label: string;
  value: any;
  selected?: boolean;
}

export interface ISelect<T> {
  type?: 'select' | 'info-select';
  items?: ISelectItem[];
  label: string;
  defaultValue?: any;
  confirmMessage?: string;
  onSelection?: (value, tableComponent: TableComponent, element) => void;
  buildItems?: (row: T) => ISelectItem[] | Observable<ISelectItem[]>;
  asyncBuildItems?: boolean;
  resetSelection?: boolean;
  trackBy?: string;
}

export enum EInfoSelectItemType {
  TYPE_LINK = 'link',
  TYPE_NORMAL = 'normal',
}

export interface IInfoSelectItem {
  label: string;
  type?: EInfoSelectItemType;
  value: any;
  popoverText?: string;
  dialogContent?: DialogData;
}

export interface IInfoSelect extends ISelect<any> {
  onSelection?: (value: any) => void;
  items?: IInfoSelectItem[];
  multiple: boolean;
  buildItems?: (row) => IInfoSelectItem[];
}
